import $ from "jquery";
import { csl, u_ } from "@pressmedia/webappbase";

export default {
	selector() {
		const container = this.container;
		
		if(!container.$self) {
			return false;
		}
		
		const $target = container.$self.children(`.${container.boxClass}`);
		if(!$target || !$target.length) {
			return false;
		}
		
		const $elm = $("<iframe/>").addClass(container.frameClass).attr({
			"name": `${container.inpType}_${container.paramKey}`,
			"data-theme": container.theme
		});
		
		this.promise = new Promise((resolve, reject) => {
			const timeout = setTimeout(reject, 1000);
			$elm.on("load", e => {
				clearTimeout(timeout);
				resolve(e.target.contentWindow);
			}).insertBefore($target);
			$target.remove();
		});
		
		return $elm;
	},
	
	async onReady($self) {
		const container = this.container;
		
		try {
			this.window = await this.promise;
			this.window.document.title = $self.attr("name");
			this.$body = $(this.window.document.body).css({
				"margin": 0,
				"overflow": "hidden",
				"padding": 0
			}).addClass(`${document.body.className} is-ready`);
			
			this.$body.parent().css({
				"min-width": container.app.browser[0] === "ie" ? "auto" : "initial"
			});
			
			this.$box = $("<div/>").addClass(`${container.boxClass} in-frame`).attr({
				"data-theme": container.theme
			}).appendTo(this.$body);
			
			delete container.app._imports[this.window.name];
			
			await Promise.all([
				// import js plugin
				async () => {
					await container._importPlugin(this.window);
					container.Quill = this.window.Quill;
				},
				
				// スタイルシートの設定
				!!this.styleSheet && new Promise((resolve, reject) => {
					container.app.require(this.styleSheet, {
						doc: this.window.document,
						type: "stylesheet",
						success: resolve,
						error: reject
					});
				}),
				
				// import plugin's css
				container._importPluginStyleSheet(this.window)
			]);
			
		} catch(e) {
			csl.warn(`${this.name}.${container.paramKey}`, "timeout");
		}
	},
	
	onChangeState(state) {
		if(u_.isNumber(state.h) && state.h !== this.state.h) {
			// * state.h is $editor's outer height
			
			switch(this.container.theme) {
				case "snow": {
					// crear frame width
					this.$self.width("");
					
					/* for jQuery - firefox bug *
					* jQueryで要素のサイズを変更した場合、変更後のサイズを即座に取得できない。
					*  jQuery関数を使用せずに直接要素のサイズへアクセスすると反映される。 */
					this.$self.get(0).clientWidth;
					
					// check `overflow-x` is needed.
					this.$box.toggleClass(
						"is-overflow-x",
						this.$editorContainer.width() < this.$editor.outerWidth(true)
					);
					
					// set editor container position to fixed
					this.$editorContainer.addClass("is-fixed");
					
					// set ghost height
					this.$ghost.outerHeight(state.h);
					
					// * for jQuery - firefox bug
					this.$box.get(0).offsetHeight;
					
					// set frame height
					this.$self.height( Math.ceil( this.$box.outerHeight(true) ) );
					
					// clear ghost height
					this.$ghost.height("");
					
					// * for jQuery - firefox bug *
					this.$self.get(0).offsetHeight;
					
					// set editor container height and clear position
					this.$editorContainer.outerHeight(
						// frame's height - toolbar's height
						Math.floor( this.$self.height() - (this.$toolbar.outerHeight(true) || 0) )
					).removeClass("is-fixed");
					
					// * for jQuery - firefox bug *
					this.$editorContainer.get(0).clientHeight;
					
					this.$editorContainer.toggleClass(
						"has-y-scrollbar",
						this.$editorContainer.height() < state.h
					);
					
					// * for jQuery - firefox bug *
					this.$editorContainer.get(0).offsetWidth;
					
					// set frame width
					this.$self.width(
						Math.ceil( this.$editorContainer.outerWidth(true) ) -
						// for firefox
						(this.$box.hasClass("is-overflow-x") ? 1 : 0)
					);
				} break;
				
				case "bubble": {
					// * for jQuery - firefox bug *
					this.$box.get(0).offsetHeight;
					
					// set frame height
					this.$self.height( Math.ceil( this.$box.outerHeight(true) ) );
				} break;
			}
		}
	},
	
	// iframeのサイズの更新関数
	updateSize() {
		if(!this.$editor) {
			return false;
		}
		
		// set state.h
		this.promise = this.promise.then(async () => {
			await this.container._promise;
			// * for jQuery - firefox bug *
			this.$editor.get(0).offsetHeight;
			return await this.setState( "h", Math.ceil( this.$editor.outerHeight(true) ) );
		});
		
		return this.promise;
	}
};
